import {openDigitalCardOnTop} from '@zzng/common/scheme/digitalcard';
import {openInappbrowser} from '@zzng/common/scheme/inappbrowser';
import {isServiceDomain} from '@zzng/common/utils/isServiceDomain';
import {executeAppScheme, isKakaotalkProtocol} from '@zzng/common/utils/scheme';

/**
 * url이 스킴이 내려올수도 있고,
 * 디지털카드 도메인 주소가 내려올 수도 있고,
 * 외부 도메인이 내려올 수 있을 때 사용하는 함수
 */
export const openLandingUrl = (schemeOrUrl: string) => {
  // URL이 kakaotalk:// 프로토콜일 경우
  if (isKakaotalkProtocol(schemeOrUrl)) {
    executeAppScheme(schemeOrUrl);
    return;
  }

  // URL이 허용된 도메인이 아닐 경우
  if (!isServiceDomain(schemeOrUrl)) {
    openInappbrowser(schemeOrUrl);
    return;
  }

  openDigitalCardOnTop(schemeOrUrl);
};
